// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + {"23":"6c4a2686ee550026905615c5f48ddf24","358":"25f62370aedc606f8ac366d0c0855ec8","795":"8a4bbda9326d76392d6429ae4a33d608"}[chunkId] + ".js";
};